module.exports = "<p>This is a binary prediction market.</p>\n<p>The collateral ratio of this market is 1:1.</p>\n";